// Typelizer digest 145a852bd6ab32177974e68ca5f5e1e8
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** PATCH /c/:company_id/ledger/documents/:document_id/breakdown */
  update: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/ledger/documents/:document_id/breakdown', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/ledger/documents/:document_id/breakdown */
  destroy: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/ledger/documents/:document_id/breakdown', params, options),
    method: 'delete',
  }),
}
